import React, { useEffect, useMemo, useState } from "react";
import { Button, Tooltip } from "react-bootstrap";
import { OverlayTrigger } from "react-bootstrap";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";

import CustomDateTime from "app/Components/DateTimeCustom/CustomDateTime";
import { formatDDMMYYYYbyYYYYMMDD } from "app/_helpers/helper";
import { capaPriorities } from "./IncidentManagement/CONSTANTS";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import Decline from "./IncidentManagement/DeclinePopup";
import { FaCheck, FaTimes } from "react-icons/fa";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";

import FormInput from "app/Components/_form/FormInput/FormInput";
import OverFlowTip from "app/Components/CommanComponents/OverFlowTip";
import { LOGGED_USER_NAME } from "./IncidentManagement/Helper";

const CapasComponent = ({
  form,
  capas = [],
  error = {},
  capasErrors = {},
  onChangeCapa = () => {},
  addCapa = () => {},
  deleteCapa = () => {},
  users = [],
  departments = [],
  incidentsOnly,
  viewOnly,
  area = [],
  capaowner = [],
  approveCapa,
  approverLevel,
  showReject = false,
  siteId,
}) => {
  const [showSubAreaText, setShowSubAreaText] = useState(false);
  let otherObj = { id: 999, name: "Other" };

  // useEffect(() => {
  //   capas.map((x) => {
  //     if (parseInt(x.subAreaId) === 999) {
  //       setShowSubAreaText(true);
  //     } else {
  //       setShowSubAreaText(false);
  //     }
  //   });
  // }, [capas]);

  const showOtherText = useMemo(() => {
    const isOtherList = [];
    capas.map((x, i) => {
      if (parseInt(x.subAreaId) === 999) {
        isOtherList[i] = { isOther: true };
      } else {
        isOtherList[i] = { isOther: false };
      }
    });
    return isOtherList;
  }, [capas]);

  const areaList = useMemo(
    () =>
      area?.filter(
        (d) =>
          capaowner
            ?.filter((d) => (siteId ? d.siteId === siteId : true))
            ?.find((data) => d?.id === data?.areaOfOperationId)?.userId
      ),
    [area, capaowner, siteId]
  );

  // console.log("capas", capas);

  return (
    <div className="table-responsive">
      <table id="capas_table" className="table table-bordered mb-3">
        <thead>
          <tr>
            <th scope="col">S.No.</th>
            {viewOnly && (
              <th scope="col" style={{ minWidth: 200 }}>
                CAPA ID
              </th>
            )}
            <th scope="col" style={{ minWidth: 200 }}>
              CAPA Type
            </th>
            <th scope="col">CAPA Description</th>
            <th scope="col" style={{ minWidth: 200 }}>
              Area
            </th>
            <th scope="col" style={{ minWidth: 200 }}>
              Sub Area
            </th>
            <th scope="col" style={{ minWidth: 150 }}>
              CAPA Owner
            </th>
            <th scope="col" style={{ minWidth: 120 }}>
              CAPA Priority
            </th>
            <th scope="col" style={{ minWidth: 130 }}>
              Completion Date
            </th>
            <th scope="col" style={{ minWidth: 130 }}>
              Incident Date
            </th>
            {viewOnly && (
              <>
                <th scope="col" style={{ minWidth: 130 }}>
                  Status
                </th>
                <th scope="col" style={{ minWidth: 130 }}>
                  CAPA Completion Date
                </th>
                <th scope="col" style={{ minWidth: 130 }}>
                  Remarks
                </th>

                <th scope="col" style={{ minWidth: 130 }}>
                  Action
                </th>
              </>
            )}
            {/* <th scope="col" style={{ minWidth: 120 }}>
                            Owner Department
                        </th> */}
            {!viewOnly && <th scope="col">Remove</th>}
          </tr>
        </thead>
        <tbody>
          {capas.length > 0 ? (
            capas.map((x, index) => {
              const subAreaData = areaList.find((y) => y.id === x.areaId);
              const subAreaOptions = subAreaData
                ? [...subAreaData.subAreaOfOperation, otherObj]
                : [];

              // if (!x.ownerId)
              //   onChangeCapa({
              //     name: "ownerId",
              //     value: capaowner.find(
              //       (data) => x.areaId === data.areaOfOperationId
              //     )?.userId,
              //     index,
              //   });

              return x.deleted ? null : (
                <tr key={index}>
                  <th>{index + 1}</th>
                  {viewOnly && (
                    <th>
                      {viewOnly ? (
                        x.capaId
                      ) : (
                        <input
                          value={x.capaId}
                          name="capaId"
                          className="form-control"
                          readOnly
                        />
                      )}
                    </th>
                  )}
                  <td>
                    {viewOnly ? (
                      x.capaType
                    ) : (
                      <>
                        <SimpleSelect
                          className="form-control"
                          name="capaType"
                          value={x.capaType}
                          onChange={({ target: { name, value } }) =>
                            onChangeCapa({ name, value, index })
                          }
                          id="id"
                          label="name"
                          options={["Select", "Corrective", "Preventive"]}
                          error={capasErrors?.capaType}
                          init="none"
                          array="single"
                        ></SimpleSelect>
                        <span className="small text-danger">
                          {capasErrors[index]?.capaType}
                        </span>
                      </>
                    )}
                  </td>
                  <td>
                    {viewOnly ? (
                      x.solution
                    ) : (
                      <>
                        <input
                          value={x.solution}
                          name="solution"
                          onChange={({ target: { name, value } }) =>
                            onChangeCapa({ name, value, index })
                          }
                          capasErrors={capasErrors?.solution}
                          className="form-control"
                        />
                        <span className="small text-danger">
                          {capasErrors[index]?.solution}
                        </span>
                      </>
                    )}
                  </td>
                  <td>
                    {viewOnly ? (
                      x.workArea?.name
                    ) : (
                      <>
                        <SimpleSelect
                          className="form-control"
                          name="areaId"
                          value={x.areaId}
                          onChange={({ target: { name, value } }) =>
                            onChangeCapa({ name, value, index })
                          }
                          id="id"
                          label="name"
                          options={areaList}
                          error={capasErrors?.areaId}
                          init="Select"
                        ></SimpleSelect>
                        <span className="small text-danger">
                          {capasErrors[index]?.areaId}
                        </span>
                      </>
                    )}
                  </td>
                  <td>
                    {viewOnly ? (
                      x.workArea?.name
                    ) : (
                      <>
                        <SimpleSelect
                          className="form-control"
                          name="subAreaId"
                          value={x.subAreaId}
                          onChange={({ target: { name, value } }) =>
                            onChangeCapa({ name, value, index })
                          }
                          id="id"
                          label="name"
                          options={subAreaOptions}
                          error={capasErrors?.subAreaId}
                          init="Select"
                        ></SimpleSelect>
                        <span className="small text-danger">
                          {capasErrors[index]?.subAreaId}
                        </span>
                      </>
                    )}
                    {showOtherText[index]?.isOther && (
                      <>
                        <FormInput
                          className="form-control"
                          name="otherSubArea"
                          value={x?.otherSubArea}
                          onChange={({ target: { name, value } }) =>
                            onChangeCapa({ name, value, index })
                          }
                          id="id"
                          label="Other Sub Area"
                          error={capasErrors[index]?.otherSubArea}
                          disabled={viewOnly ? true : false}
                        ></FormInput>
                        {/* <span className="small text-danger">
                          {capasErrors[index]?.otherSubArea}
                        </span> */}
                      </>
                    )}
                  </td>
                  <td>
                    {viewOnly ? (
                      x.owner ? (
                        `${x.owner.firstName} ${x.owner.lastName}`
                      ) : (
                        `${
                          users.find((user) => user.id === +x.ownerId)?.firstName || ""
                        } ${users.find((user) => user.id === +x.ownerId)?.lastName || ""}`
                      )
                    ) : (
                      <>
                        {/* <select
                          value={x.ownerId}
                          name="ownerId"
                          onChange={({ target: { name, value } }) => onChangeCapa({ name, value, index })}
                          capasErrors={capasErrors?.ownerId}
                          className="form-control"
                          disabled
                        >
                          {capaowner.map((data) => {
                            if (x.areaId === data.areaOfOperationId) {
                              return (
                                <option key={x.id} value={data.userId}>
                                  {data.user.firstName} {data.user.lastName}
                                </option>
                              );
                            }
                            return null;
                          })}
                        </select> */}
                        <input
                          value={LOGGED_USER_NAME()}
                          name="solution"
                          // onChange={({ target: { name, value } }) => onChangeCapa({ name, value, index })}
                          // capasErrors={capasErrors?.solution}
                          className="form-control"
                          disabled
                        />
                        <span className="small text-danger">
                          {capasErrors[index]?.ownerId}
                        </span>
                      </>
                    )}
                  </td>
                  <td>
                    {viewOnly ? (
                      x.priority
                    ) : (
                      <>
                        <SimpleSelect
                          value={x.priority}
                          name="priority"
                          onChange={({ target: { name, value } }) =>
                            onChangeCapa({ name, value, index })
                          }
                          className="form-control"
                          options={Object.keys(capaPriorities)}
                          object={capaPriorities}
                          error={capasErrors?.priority}
                        ></SimpleSelect>
                        <span className="small text-danger">
                          {capasErrors[index]?.priority}
                        </span>
                      </>
                    )}
                  </td>
                  <td>
                    {viewOnly ? (
                      formatDDMMYYYYbyYYYYMMDD(x.completionDate)
                    ) : (
                      <div className="form-group">
                        <div className="calenderFixed">
                          <CustomDateTime
                            name="completionDate"
                            value={x.completionDate}
                            closeOnSelect
                            readOnly
                            // disabled={true}
                            error={capasErrors?.completionDate}
                            onChange={(moment, name) =>
                              onChangeCapa({
                                index,
                                value: moment.format("YYYY-MM-DD"),
                                name,
                              })
                            }
                          />
                        </div>
                        <span className="small text-danger">
                          {capasErrors[index]?.completionDate}
                        </span>
                      </div>
                    )}
                  </td>
                  <td>
                    {viewOnly ? (
                      formatDDMMYYYYbyYYYYMMDD(x.completionDate)
                    ) : (
                      <div className="form-group">
                        <div className="calenderFixed">
                          <CustomDateTime
                            name="completionDate"
                            value={x.completionDate}
                            closeOnSelect
                            readOnly
                            disabled={true}
                            error={capasErrors?.completionDate}
                            onChange={(moment, name) =>
                              onChangeCapa({
                                index,
                                value: moment.format("YYYY-MM-DD"),
                                name,
                              })
                            }
                          />
                        </div>
                        <span className="small text-danger">
                          {capasErrors[index]?.completionDate}
                        </span>
                      </div>
                    )}
                  </td>
                  {viewOnly && (
                    <>
                      <td>{x.capaStatus}</td>
                      <td>
                        {x.completionDate
                          ? formatDDMMYYYYbyYYYYMMDD(x.completionDate)
                          : ""}
                      </td>
                      <td>
                        <OverFlowTip>{x.actionsOrResolutions}</OverFlowTip>
                      </td>
                      <td>
                        {x.capaStatus === "Open" ? (
                          "N/A"
                        ) : x.capaStatus === "Completed" && x.isApproved ? (
                          "N/A"
                        ) : x.capaStatus === "Completed" &&
                          approverLevel === "so" &&
                          x.isApprovedBySO ? (
                          "N/A"
                        ) : x.capaStatus === "Completed" &&
                          approverLevel === "mm" &&
                          (x.isApprovedByMM || !x.isApprovedBySO) ? (
                          "N/A"
                        ) : (
                          <div className="actionIconsGroup">
                            <Decline
                              id={x.capaId}
                              onSubmit={(obj) =>
                                approveCapa(index, x.id, {
                                  ...obj,
                                  isApproved: 1,
                                })
                              }
                              title="Approve"
                              name={
                                <CustomTooltip tooltip="Approve">
                                  <FaCheck />
                                </CustomTooltip>
                              }
                              iconClass={"icons text-success"}
                            />
                            {showReject && (
                              <Decline
                                id={x.capaId}
                                onSubmit={(obj) =>
                                  approveCapa(index, x.id, {
                                    ...obj,
                                    isApproved: 0,
                                  })
                                }
                                title="Reject"
                                name={
                                  <CustomTooltip tooltip="Reject">
                                    <FaTimes />
                                  </CustomTooltip>
                                }
                                iconClass={"icons text-danger"}
                              />
                            )}
                          </div>
                        )}
                      </td>
                    </>
                  )}
                  {!viewOnly && (
                    <td>
                      <div className="actionIconsGroup">
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id="tooltip-top">Delete</Tooltip>}
                        >
                          <span
                            onClick={() => deleteCapa(index)}
                            className="pointer icons text-danger font-20"
                          >
                            <FiMinusCircle />
                          </span>
                        </OverlayTrigger>
                      </div>
                    </td>
                  )}
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="10" align="center">
                {/* <div className="alert alert-danger d-inline-block m-0">
                                    <strong>Empty</strong>
                                </div> */}
              </td>
            </tr>
          )}
          {!viewOnly && capas.length !== 4 && (
            <tr>
              <td colSpan="10">
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="tooltip-top">Add Row</Tooltip>}
                >
                  <Button className="addRowPluseIcon" onClick={addCapa}>
                    <FiPlusCircle />
                  </Button>
                </OverlayTrigger>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CapasComponent;
